module.exports = __webpack_public_path__ + "img/ocean-resort-2.d639b49e.jpg";